import NamedDto from 'modules/base/dto/NamedDto';

export class AnnotationEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {number} */
		this.project = null;
		/** @type {number} */
		this.minValue = null;
		/** @type {number} */
		this.maxValue = null;
	}

	/**
	 * @typedef {Object} _AnnotationEditDtoProps
	 * @property {number} project
	 * @property {number} minValue
	 * @property {number} maxValue
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _AnnotationEditDtoProps} AnnotationEditDtoProps
	 */
	/**
	 *
	 * @param {AnnotationEditDtoProps} props
	 * @returns {AnnotationEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.project = props.project;
		this.minValue = props.minValue;
		this.maxValue = props.maxValue;
		return this;
	}
}

export default AnnotationEditDto;
